<template>
    <v-app>
        <div v-if="!isAuthenticated">
            <frontend-layout>
            </frontend-layout>
        </div>
        <div v-else>
            <user-layout>
            </user-layout>
        </div>
        <v-dialog v-if="refreshDialog" v-model="refreshDialog" max-width="500px" persistent>
            <v-card class="pa-4">
                    <v-card-title class="px-4">
                        <h2 class="title">New Version is Available!</h2>
                    </v-card-title>
                    <v-flex class="xs12 py-4 px-5">
                    <div class="dialog-warning-note mb-4">
                        <v-layout class="align-center fill-height">
                        <v-icon left color="info" class="mr-2 d-flex">new_releases</v-icon>
                        <span class="d-flex">Please refresh now to use latest available features.</span>
                        </v-layout>
                    </div>
                    </v-flex>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" @click="refresh">Refresh Now</v-btn>
                    </v-card-actions>
            </v-card>
        </v-dialog>
        <Footer></Footer>
    </v-app>
</template>

<script>
    import { mapGetters, mapMutations, mapActions } from "vuex";
    import FrontendLayout from "./components/FrontendLayout";
    import UserLayout from "./components/UserLayout";
    import Footer from "./components/Footer"
    import {PUSHER_KEY} from "@/common/config";
    import Pusher from 'pusher-js'

    export default {
        name: 'App',
        computed: {
            ...mapGetters(["currentUser", "isAuthenticated"]),
        },
        components: {UserLayout, FrontendLayout, Footer},
        data() {
            return {
                refreshDialog: false
            }
        },
        created() {
            this.subscribeVersion()
            this.getVersionFromLocalStorage()
            this.setOrganizationBranding()
            // this.logVersion()
            // console.log('ROOT_API', process.env.ROOT_API)
        },
        methods: {
            ...mapActions(['setOrganizationBranding']),
            ...mapMutations({ getVersionFromLocalStorage: 'refresh' }),
            subscribeVersion() {
                let pusher = new Pusher(PUSHER_KEY, {
                    cluster: 'us2',
                    forceTLS: true
                });
                let channel = pusher.subscribe('employee_version');
                channel.bind('NewVersionEmployeeDeployed', data => {
                    console.log('New Version Deployed')
                    this.refreshDialog = true
                });
            },
            // logVersion() {
            //     console.log('package.json version: ', process.env.VUE_APP_VERSION)
            // }
            refresh () {
                this.refreshDialog = false
                window.location.reload(true)
            }
        }
    }
</script>

<style src="./assets/sass/custom.css"> 

</style>
